'use client'

interface ErrorProps {
  error: Error
  reset: () => void
}

export default function ErrorPage({ error, reset }: ErrorProps) {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 text-center">
      <svg
        className="mb-4 h-12 w-12 text-[var(--color-error)]"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
      <h1 className="text-[var(--text-xl)] font-bold text-[var(--color-text-primary)]">
        Something went wrong
      </h1>
      <p className="mt-2 max-w-sm text-[var(--text-sm)] text-[var(--color-text-secondary)]">
        {error.message || 'An unexpected error occurred. Please try again.'}
      </p>
      <button
        type="button"
        onClick={reset}
        className="mt-6 rounded-[var(--radius-md)] bg-[var(--color-brand-indigo)] px-5 py-2.5 text-[var(--text-sm)] font-medium text-white transition-colors hover:bg-[var(--color-brand-violet)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--color-brand-indigo)]"
      >
        Try Again
      </button>
    </div>
  )
}
